module.exports = __webpack_public_path__ + "static/media/popupclose.4678a677.svg";